import { EnumLiteralsOf } from '../types/helpers'

export const FormTypes = {
  EDIT: 'edit',
  NEW: 'new',
  MANUAL: 'manual',
} as const

export type FormType = EnumLiteralsOf<typeof FormTypes>

export const citationMock = {
  citationProjectId: null,
  sourceType: 'WEBSITE',
  contributors: [],
  annotation: '',
  pubType: 'PUBONLINE',
  data: {
    annotation: '',
    source: 'website',
    pubtype: {
      main: 'pubonline',
      suffix: '',
    },
    doi: {},
    website: {
      title: '',
    },
    other: {
      sponsor: 'publisher',
    },
    pubonline: {
      url: 'https://en.wikipedia.org/wiki/Main_page',
      title: 'Wikipedia',
      inst: 'Wikimedia Foundation',
      day: '30',
      month: 'april',
      year: '2017',
      dayaccessed: '07',
      monthaccessed: 'february',
      yearaccessed: '2023',
    },
  },
}
export const initialCitationMock = {
  citationProjectId: null,
  sourceType: 'WEBSITE',
  contributors: [],
  annotation: '',
  pubType: 'PUBONLINE',
  data: {
    annotation: '',
    source: 'website',
    pubtype: {
      main: 'pubonline',
      suffix: '',
    },
    doi: {},
    website: {
      title: '',
    },
    other: {
      sponsor: 'publisher',
    },
    pubonline: {},
  },
}
